import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Demmeler extends Component {
  render() {
    return (
      <div className='container-fluid'>

        <div className="supMain">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Demmeler</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt=""/>
        </div>
        <div className="supMainText">
          <h1>DEMMELER</h1>
            <Grid className="supMainInfo">
              <Row>
                <Col xsHidden smHidden md={3}>
                  <Carousel  controls={false} interval={3000}>
                    <Carousel.Item >
                        <img  src={InfoJumb1}  alt=""  height="100%" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img  src={InfoJumb2} alt=""  height="100%"/>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img  src={InfoJumb3} alt=""  height="100%" />
                    </Carousel.Item>
                  </Carousel>
                  </Col>
                <Col xsHidden md={8}>
                  <h4>Seit über 50 Jahren beschäftigt sich Demmeler mit den Aufgabenstellungen rund um die Fertigungsoptimierung. In diesen 50 Jahren hat sich Demmeler zum Innovations- und Qualitätsführer im Bereich Arbeitstisch- und Spannsysteme, Manipulatoren und Maschinenkomponenten entwickelt. Demmeler war federführend, wenn Innovationen und entscheidende Verbesserungen eingeführt wurden. Die komplette Entwicklung und Fertigung erfolgt am Firmensitz in Heimertingen. Mit Produkten Made in Germany stellen wir höchste Qualitätsansprüche sicher. Kurze Wege in unserer Ideenfabrik sorgen für eine außergewöhnliche Innovationskraft. Durch langjährige, starke Partnerschaften profitieren wir und unsere Kunden gleichermaßen.
                </h4>
                </Col>
                <Col xs={12}  smHidden mdHidden lgHidden>
                  <h4>Seit über 50 Jahren beschäftigt sich Demmeler mit den Aufgabenstellungen rund um die Fertigungsoptimierung. In diesen 50 Jahren hat sich Demmeler zum Innovations- und Qualitätsführer im Bereich Arbeitstisch- und Spannsysteme, Manipulatoren und Maschinenkomponenten entwickelt.
                </h4>
                </Col>
                <Col xs={12} md={{ span: 7, offset: 2 }}>
                  <Button className="supMainButtonWebPage" variant="light" href="https://www.demmeler.com/" target="_blank">Hersteller Homepage</Button>
                </Col>
              </Row>
            </Grid>
            <br/>
        </div>



        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Extrem lange Haltbarkeit</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Optimaler Zugang zu Werkstücken</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>100% Eigenfertigung Made in Germany</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Nachhaltigkeit im Produktionsbereich</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Know How seit 1961</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Innovative Zukunftslösungen</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Optimaler Zugang zu Werkstücken</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; 100% Eigenfertigung Made in Germany</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Know How seit 1961</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Innovative Zukunftslösungen</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>
          <Grid className="gridUp">
            <br/>
            <center>
            <h1>Produkte</h1>
            </center>
            <br/><br/>
            <Row className="show-grid">
              <Col  xs={12} sm={6}>
                <center>
                  <div className="productsButton">
                    <Link to="/Suppliers/Demmeler/Schweißtische"><h4 className="buttonBlue">Schweißtische</h4>
                      <h5>Mit unserem 3D Schweißtisch und Spannsystem haben Sie für jede Ihrer Herausforderungen die passende Lösung zum Spannen, Wenden und Positionieren von Werkstücken parat.</h5>
                      <p>Mehr ...</p>
                    </Link>
                  </div>
              </center>
              </Col>
              <Col  xs={12} sm={6}>
                <center>
                  <div className="productsButton">
                    <Link to="/Suppliers/Demmeler/Innovationen"><h4 className="buttonBlue">Innovationen</h4>
                  <h5>Demmeler bietet Innovative Lösungen zum automatisierten und unterstützten Schweißen an.</h5>
                <p>Mehr ...</p>
              </Link>
              </div>
              </center>
              </Col>
            </Row>
          </Grid>
            <br/>
        </section>
        </div>
    );
  }
}

export default Demmeler;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/demmeler/mainPageSup.js